// extracted by mini-css-extract-plugin
export var formSection = "MobileEmbed-module--formSection--oiFP3";
export var formWrapper = "MobileEmbed-module--formWrapper--QJ-CX";
export var imageBanner = "MobileEmbed-module--imageBanner--1Bnv1";
export var formContainer = "MobileEmbed-module--formContainer--Fget4";
export var formElements = "MobileEmbed-module--formElements--1yS-o";
export var heading = "MobileEmbed-module--heading--3QxE2";
export var subtitle = "MobileEmbed-module--subtitle--3s1M0";
export var inputContainer = "MobileEmbed-module--inputContainer--_7ttG";
export var submitButton = "MobileEmbed-module--submitButton--v5dDn";